export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);

// iPadOS reports a desktop "Macintosh" UA, so also treat a touch-capable Mac as iOS.
export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

export const endpoints = {
  status: '/status/',
  questions: '/questions/',
  answersConfirmation: '/answers/',
  answersUploadRejected: '/answers/upload-rejected',
  interviewPreview: '/interview-preview/',
  interactions: '/interview-interactions/',
  qrApplyJob: '/qr-apply/:property_id',
  qrApplyClient: '/qr-apply/client/:client_id',
};

export const routes = {
  root: '/',
  apply: '/qr-apply/:property_id',
  applyForm: '/qr-apply/:property_id/form',
  applyClient: '/qr-apply/client/:client_id',
  applyFormFinish: '/qr-apply/:property_id/finish',
  tutorial: '/tutorial',
  residency: '/residency',
  questions: '/questions',
  answers: '/answers',
  finish: `/finish`,
  interviewPreview: '/interview-preview',
  offerConfirmation: '/offer-confirmation',
  interactionsConfirmation: '/interactions-confirmation',
};

export const DEBUG = 'debug';
export const testInvitationKey = 'AAC25A';
